import React from 'react';

const FilledCaretUpIcon = (props) => (
  <svg {...props} viewBox='0 0 5 4' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.03109 0L4.06218 3.25H0L2.03109 0Z' fill={props.fill} />
  </svg>
);

export default FilledCaretUpIcon;
